<!-- Header -->
<header id="page-header">
  <!-- Header Content -->
  <div class="content-header">
    <!-- Left Section -->
    <div class="content-header-section">
      <!-- Toggle Sidebar -->
      <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
      <button type="button" class="btn btn-circle btn-dual-secondary" data-toggle="layout" data-action="sidebar_toggle">
        <i class="fa fa-navicon"></i>
      </button>
      <!-- END Toggle Sidebar -->

      <!-- Open Search Section -->
      <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
      <button *ngIf="!isExternalUser" type="button" class="btn btn-circle btn-dual-secondary" data-toggle="layout" data-action="header_search_on">
        <i class="fa fa-search"></i>
      </button>
      <!-- END Open Search Section -->

    </div>
    <!-- END Left Section -->

    <!-- Right Section -->
    <div class="content-header-section">
      <!-- User Dropdown -->
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-rounded btn-dual-secondary" id="page-header-user-dropdown" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          {{this.currentUser.firstName}}
          <i class="fa fa-angle-down ml-5"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right min-width-150" aria-labelledby="page-header-user-dropdown">

          <a class="dropdown-item" [routerLink]="['/team', this.currentUser._id]">
            <i class="si si-user mr-5"></i> Profile
          </a>



          <a class="dropdown-item d-flex align-items-center justify-content-between" data-toggle="layout" [routerLink]="['/team/tasks']">
            <span>
              <i class="fa fa-check mr-5"></i> Tasks</span>
            <span class="badge badge-primary">{{ outstandingTasksCount }}</span>
            <!-- <i class="si si-check mr-5" ></i> Tasks -->
          </a>


          <div class="dropdown-divider"></div>

          <!-- Toggle Side Overlay -->
          <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
          <a class="dropdown-item" data-toggle="layout" [routerLink]="['/account']">
            <i class="si si-wrench mr-5"></i> Settings
          </a>
          <!-- <a class="dropdown-item" data-toggle="layout" [routerLink]="['/account/change-password']">
            <i class="si si-lock mr-5" ></i> Change Password
          </a> -->
          <!-- END Side Overlay -->

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" [routerLink]="['/logout']">
            <i class="si si-logout mr-5"></i> Sign Out
          </a>
        </div>
      </div>
      <!-- END User Dropdown -->

      <!-- Toggle Side Overlay -->
      <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
      <button type="button" class="btn btn-circle btn-dual-secondary" data-toggle="layout" data-action="side_overlay_toggle">
        <i class="fa fa-tasks"></i>
      </button>
      <!-- END Toggle Side Overlay -->
    </div>
    <!-- END Right Section -->
  </div>
  <!-- END Header Content -->

  <!-- Header Search -->
  <div id="page-header-search" class="overlay-header">
    <div class="content-header content-header-fullrow">
      <form action="" method="post">
        <div class="input-group">
          <span class="input-group-btn">
            <!-- Close Search Section -->
            <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
            <button type="button" class="btn btn-secondary px-15" data-toggle="layout" data-action="header_search_off">
              <i class="fa fa-times"></i>
            </button>
            <!-- END Close Search Section -->
          </span>
          <input type="text" class="form-control" placeholder="Search or hit ESC.." id="page-header-search-input" name="page-header-search-input"
            (keyup)="onSearch($event)">
          <span class="input-group-btn">
            <button type="submit" class="btn btn-secondary px-15">
              <i class="fa fa-search"></i>
            </button>
          </span>

        </div>
      </form>
    </div>
  </div>
  <!-- END Header Search -->

  <!-- Header Loader -->
  <div id="page-header-loader" class="overlay-header bg-primary">
    <div class="content-header content-header-fullrow text-center">
      <div class="content-header-item">
        <i class="fa fa-sun-o fa-spin text-white"></i>
      </div>
    </div>
  </div>
  <!-- END Header Loader -->
</header>
<!-- END Header -->



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/topbar/topbar.component.html